import r from"styled-components";import{theme as p}from"../../../theme.js";const o=r.div`
  display: flex;
  gap: ${p.spacing*2}px;
  flex-wrap: wrap;
  div {
    cursor: pointer;
  }
`;export{o as Container};
